import { createContext, useContext, useState, ReactNode } from 'react';
import { signersData } from '../types/interfaces';

type SignersContextType = {
  savedSigners: signersData[];
  setSavedSigners: React.Dispatch<React.SetStateAction<signersData[]>>;
};

const SignersContext = createContext<SignersContextType | undefined>(undefined);

type SignersProviderProps = {
  children: ReactNode;
};

export const SignersProvider = ({ children }: SignersProviderProps) => {
  const [savedSigners, setSavedSigners] = useState<signersData[]>([]);

  return (
    <SignersContext.Provider value={{ savedSigners, setSavedSigners }}>
      {children}
    </SignersContext.Provider>
  );
};

export const useSignersContext = (): SignersContextType => {
  const context = useContext(SignersContext);
  if (!context) {
    throw new Error(
      'useSignersContext debe usarse dentro de un SignersProvider'
    );
  }
  return context;
};
